import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UpdatevesselDataComponent } from '../updatevessel-data/updatevessel-data.component';
import { UpdatevesselDataRoutingModule } from './updatevessel-data-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    UpdatevesselDataComponent
  ],
  imports: [
    CommonModule,
    UpdatevesselDataRoutingModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class UpdatevesselDataModule {} 